import { type ProgressProps, Progress as AntdProgress } from 'antd';

import useStepStore from '@/stores/steps';

/** Follows the active theme primary, so light and dark need no manual branch. */
const strokeColor: ProgressProps['strokeColor'] = {
  '0%': 'var(--uizz-antd-color-primary-active)',
  '100%': 'var(--uizz-antd-color-primary)'
};

const Progress = () => {
  const progress = useStepStore(({ step, steps, stepData }) => {
    if (stepData?.progress) {
      return stepData.progress;
    }

    const stepsWithProgress = steps.map((item, index) => ({ ...item, index })).filter(s => s.progress !== undefined);
    const currentRange = stepsWithProgress.reduce(
      (range, stepWithProgress) => {
        if (stepWithProgress.index <= step && stepWithProgress.index >= range.min.index) {
          range.min = {
            index: stepWithProgress.index,
            progress: stepWithProgress.progress!
          };
        }

        if (stepWithProgress.index >= step && stepWithProgress.index <= range.max.index) {
          range.max = {
            index: stepWithProgress.index,
            progress: stepWithProgress.progress!
          };
        }

        return range;
      },
      { min: { index: 0, progress: 0 }, max: { index: steps.length - 1, progress: 100 } }
    );

    const diferenceBetweenIndex = currentRange.max.index - currentRange.min.index;
    const diferenceBetweenProgress = currentRange.max.progress - currentRange.min.progress;
    const currentStepOffset = step - currentRange.min.index;

    return currentRange.min.progress + (currentStepOffset * diferenceBetweenProgress) / diferenceBetweenIndex;
  });

  return (
    <AntdProgress
      showInfo={false}
      className='leading-0! **:rounded-none!'
      percent={progress}
      size={{ height: 6 }}
      strokeColor={strokeColor}
    />
  );
};

export default Progress;
